"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setIsMoving = exports.create = exports.get = void 0;
var spritesBackground_1 = require("@crokinole/recyclers/spritesBackground");
var diveColors_1 = require("@dive/colors/diveColors");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var namespace = 'crokinole_flyingPieces';
var verbose = false;
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    assert_sidecar_1.assert.notNil(_obj);
    return _obj;
}
exports.get = get;
function create() {
    return {
        elapsedSeconds: 0,
        isMoving: true,
    };
}
exports.create = create;
function setIsMoving(isMoving) {
    get().isMoving = isMoving;
}
exports.setIsMoving = setIsMoving;
var update = function () {
    var delta = common_sidecar_1.common.getUpdateDelta();
    // let elapsed = common.getElapsedTime()
    if (get().isMoving) {
        get().elapsedSeconds += delta;
    }
    var elapsed = get().elapsedSeconds;
    var numToasters = 10;
    var offset = 0.5;
    var objectSizeW = 400;
    var objectSizeH = 200;
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    // TODO: new recycler
    var x = 0;
    var y = 0;
    var densityX = 400;
    var densityY = 200;
    var cycleTime = 15;
    var cycleT = (elapsed % cycleTime) / cycleTime;
    var numCycles = Math.floor(elapsed / cycleTime);
    var rowIdx = 0;
    var itemIdx = 0;
    var rendered = 0;
    var sLineOffsetX = densityX * (cycleT - 0.5);
    var sLineOffsetY = densityY * (cycleT - 0.5);
    var draw = function (x, y) {
        if (x + objectSizeW < 0) {
            return 0;
        }
        if (x > gb.width + 100) {
            return 0;
        }
        if (y + objectSizeH < 0) {
            return 0;
        }
        if (y > gb.height + 50) {
            return 0;
        }
        var wingDistance = 200;
        var puck = spritesBackground_1.spritesBackground.getNext(x + wingDistance / 2, y + 35, sprites_sidecar_1.sprites.crokinoleCrokinolePiece[0]);
        puck.tint = diveColors_1.diveColors.pureWhite;
        puck.scale = 1.0;
        puck.rotation = 0; // item.rotation()
        var wing1 = spritesBackground_1.spritesBackground.getNext(x, y, sprites_sidecar_1.sprites.crokinoleWing[0]);
        wing1.tint = diveColors_1.diveColors.pureWhite;
        wing1.rotation = 0; // item.rotation()
        var wing2 = spritesBackground_1.spritesBackground.getNext(x + wingDistance, y, sprites_sidecar_1.sprites.crokinoleWing[0]);
        wing2.tint = diveColors_1.diveColors.pureWhite;
        wing2.rotation = 0; // item.rotation()
        wing2.scaleX = -wing1.scaleX;
        return 1;
    };
    for (var sy = -objectSizeH; sy < gb.height + objectSizeH; sy += densityY) {
        rowIdx++;
        var xOffset = 0;
        if (rowIdx % 2 === numCycles % 2) {
            xOffset = (densityX * 1) / 2;
        }
        // if (rowIdx % 3 === 0) {
        //   xOffset = (densityX * 1) / 3
        // }
        // if (rowIdx % 3 === 1) {
        //   xOffset = (densityX * 2) / 3
        // }
        for (var sx = -objectSizeW - xOffset; sx < gb.width + objectSizeW; sx += densityX) {
            x = sx + sLineOffsetX;
            y = sy - sLineOffsetY;
            itemIdx++;
            rendered += draw(x, y);
        }
    }
    if (verbose) {
        console.log(namespace, 'itemIdx', itemIdx, cycleT, rendered);
    }
    //   rowIdx++
    //   // Calculate length of our line
    //   let length = Math.sqrt(2) * sy
    //   for (let sLine = 0; sLine < length; sLine += densityX) {
    //     x = 0
    //     y = sy
    //     let slopeY = -1
    //     let slopeX = 1
    //     let t = sLine / length
    //     let sLineOffset = densityX * (cycleT - 0.5)
    //     if (rowIdx % 2 === 0) {
    //       sLineOffset -= densityX * 0.5
    //     }
    //     x += slopeX * (sLine + sLineOffset)
    //     y += slopeY * (sLine + sLineOffset)
    //     draw(x, y)
    //   }
    //   // draw(x + 100, y + 100)
    // }
};
exports.update = update;
